import Vue from "vue";
import PouchDB from "pouchdb";

const mkdb = () => {
  let create = name => {
    let o = new PouchDB(name);
    console.log("[side effect]", name, o);
    o.on("change", console.log);
    return o;
  };

  let commandes = create("commandes");
  let customers = create("customers");
  let options = create("options");

  console.log("databases created");
  return { commandes, customers, options };
};

const databases = mkdb();
databases.install = () => {
  Object.defineProperty(Vue.prototype, "$db", {
    get() {
      return databases;
    }
  });
};

export { databases }
